export const homeData = {
  hero: {
    title: "探花系列精品聚合",
    subtitle: "汇聚国内探花、探花精选、探花91等优质资源，聚焦顶级探花大师与探花直播",
    ctaText: "浏览精选内容",
    backgroundImage:
      "https://readdy.ai/api/search-image?query=Elegant%20dark%20abstract%20cinematic%20background%20with%20warm%20golden%20light%20accents%2C%20luxury%20texture%2C%20minimalist%20composition%2C%20subtle%20grain%2C%20high-end%20editorial%20style%20photography&width=1600&height=900&seq=hero-bg-01&orientation=landscape",
  },
  categories: [
    {
      id: "domestic",
      slug: "domestic",
      name: "国内探花",
      description: "精选国内优质探花内容，涵盖各地特色资源",
      image:
        "https://readdy.ai/api/search-image?query=Modern%20Chinese%20urban%20night%20scene%20with%20neon%20lights%2C%20warm%20amber%20tones%2C%20cinematic%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%20style&width=800&height=600&seq=cat-domestic-01&orientation=landscape",
      count: 128,
    },
    {
      id: "selection",
      slug: "selection",
      name: "探花精选",
      description: "人工精选高品质探花作品，每日更新",
      image:
        "https://readdy.ai/api/search-image?query=Luxury%20golden%20spotlight%20on%20dark%20stage%2C%20warm%20amber%20lighting%2C%20elegant%20minimalist%20composition%2C%20high-end%20fashion%20editorial%20style%2C%20soft%20focus%20background&width=800&height=600&seq=cat-selection-01&orientation=landscape",
      count: 256,
    },
    {
      id: "tanhua91",
      slug: "tanhua91",
      name: "探花91",
      description: "91探花系列独家聚合，热门资源一站获取",
      image:
        "https://readdy.ai/api/search-image?query=Abstract%20geometric%20shapes%20with%20warm%20coral%20and%20amber%20gradients%2C%20modern%20digital%20art%2C%20minimalist%20clean%20composition%2C%20premium%20editorial%20style&width=800&height=600&seq=cat-91-01&orientation=landscape",
      count: 312,
    },
    {
      id: "live",
      slug: "live",
      name: "探花直播",
      description: "实时探花直播频道，热门主播在线互动",
      image:
        "https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20setup%20with%20professional%20lighting%2C%20warm%20tones%2C%20modern%20minimalist%20interior%2C%20soft%20ambient%20glow%2C%20editorial%20photography&width=800&height=600&seq=cat-live-01&orientation=landscape",
      count: 64,
    },
    {
      id: "top-master",
      slug: "top-master",
      name: "顶级探花大师",
      description: "行业顶级探花大师作品集，大师级制作水准",
      image:
        "https://readdy.ai/api/search-image?query=Professional%20film%20director%20chair%20on%20elegant%20dark%20set%2C%20warm%20spotlight%2C%20cinematic%20atmosphere%2C%20minimalist%20luxury%20composition%2C%20editorial%20style&width=800&height=600&seq=cat-master-01&orientation=landscape",
      count: 48,
    },
    {
      id: "zone1",
      slug: "zone1",
      name: "探花一区",
      description: "探花一区专区，经典内容完整收录",
      image:
        "https://readdy.ai/api/search-image?query=Vintage%20film%20reels%20and%20cinema%20equipment%20with%20warm%20lighting%2C%20nostalgic%20atmosphere%2C%20soft%20amber%20tones%2C%20editorial%20product%20photography&width=800&height=600&seq=cat-zone1-01&orientation=landscape",
      count: 198,
    },
  ],
  featured: [
    {
      id: "2024-nian-du-tanhua-dashibang",
      title: "2024年度探花大师排行榜发布",
      description: "盘点年度最具人气的探花大师，从作品质量到粉丝口碑，全方位解读行业标杆",
      image:
        "https://readdy.ai/api/search-image?query=Elegant%20award%20trophy%20on%20marble%20pedestal%2C%20warm%20golden%20spotlight%2C%20dark%20luxury%20background%2C%20minimalist%20composition%2C%20high-end%20editorial%20photography&width=600&height=800&seq=feat-01&orientation=portrait",
      tag: "热门",
      date: "2024-12-15",
    },
    {
      id: "tanhua-91-zuixin-xilie-jiexi",
      title: "探花91最新系列全面解析",
      description: "深度解析91探花最新系列作品，从技术手法到内容创新，全面剖析",
      image:
        "https://readdy.ai/api/search-image?query=Modern%20video%20production%20camera%20on%20tripod%20with%20warm%20studio%20lighting%2C%20professional%20equipment%2C%20dark%20background%2C%20editorial%20product%20photography&width=600&height=800&seq=feat-02&orientation=portrait",
      tag: "推荐",
      date: "2024-12-10",
    },
    {
      id: "guonei-tanhua-hangye-qushi-baogao",
      title: "国内探花行业趋势报告",
      description: "2024年国内探花行业发展趋势深度报告，市场规模、用户需求全面解读",
      image:
        "https://readdy.ai/api/search-image?query=Abstract%20data%20visualization%20with%20warm%20amber%20and%20coral%20gradients%2C%20flowing%20lines%2C%20modern%20digital%20art%2C%20minimalist%20clean%20design&width=600&height=800&seq=feat-03&orientation=portrait",
      tag: "独家",
      date: "2024-12-05",
    },
    {
      id: "dingji-tanhua-dashizhuanfang-chuangzuo",
      title: "顶级探花大师专访：创作背后的故事",
      description: "独家专访三位顶级探花大师，揭秘创作灵感来源与幕后故事",
      image:
        "https://readdy.ai/api/search-image?query=Professional%20interview%20setting%20with%20elegant%20chair%20and%20warm%20spotlight%2C%20dark%20moody%20background%2C%20cinematic%20atmosphere%2C%20editorial%20style&width=600&height=800&seq=feat-04&orientation=portrait",
      tag: "专访",
      date: "2024-11-28",
    },
  ],
  stats: [
    { label: "精品资源", value: "10,000+" },
    { label: "每日更新", value: "200+" },
    { label: "活跃用户", value: "500,000+" },
    { label: "探花大师", value: "500+" },
  ],
  cta: {
    title: "加入探花爱好者社区",
    description: "订阅我们的资讯，第一时间获取最新探花系列资源更新和行业动态",
    buttonText: "立即订阅",
    backgroundImage:
      "https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20background%20with%20golden%20and%20amber%20tones%2C%20soft%20light%20rays%2C%20elegant%20minimalist%20composition%2C%20premium%20editorial%20style&width=1600&height=600&seq=cta-bg-01&orientation=landscape",
  },
  testimonials: [
    {
      id: "t1",
      quote: "这个平台汇聚的资源非常全面，更新也很及时，是我每天必看的网站。",
      author: "资深探花爱好者",
      role: "用户点评",
    },
    {
      id: "t2",
      quote: "作为内容创作者，这里给了我很多灵感和参考，非常专业的聚合平台。",
      author: "独立制作人",
      role: "行业从业者",
    },
    {
      id: "t3",
      quote: "界面设计简洁大方，内容分类清晰，找资源非常方便。",
      author: "新用户",
      role: "用户体验",
    },
  ],
};
